import { t } from "i18next";
import { slugify } from "neetocist";
import { identity, pluck, prop, reject } from "ramda";

export const getOrderedOptions = (options = []) =>
  options.sort((a, b) => a.position - b.position);

export const filterDeletedRecords = (options, destroyFlagName) =>
  reject(prop(destroyFlagName), options);

export const randomId = () => Math.random().toString(36).substring(2, 13);

export const getUniqueOptionId = option =>
  option.altId ||
  option.id?.toString() ||
  option.position?.toString() ||
  slugify(option.label ?? "");

export const generatePlaceholder = (itemLabel, count) =>
  `${itemLabel} ${count + 1}`;

export const generateLabel = (itemLabel, options, count) => {
  const labelCount = count || options.length + 1;
  const tempLabel = `${itemLabel} ${labelCount}`;
  const isDuplicateLabel = pluck("label", options).includes(tempLabel);

  return isDuplicateLabel
    ? generateLabel(itemLabel, options, labelCount + 1)
    : tempLabel;
};

export const resolveFormikValue = (path, values) => {
  if (!path || typeof path !== "string") {
    return [];
  }

  return path
    .replace(/\[|\]/g, ".")
    .split(".")
    .filter(Boolean)
    .reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      values
    );
};

export const handleNumberKeyDown = (event, onKeyDown) => {
  const allowedKeys = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "-",
  ];

  const controlKeys = [
    "Backspace",
    "Delete",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    "Enter",
  ];

  if (
    (event.ctrlKey || event.metaKey) &&
    ["a", "c", "v", "x", "z"].includes(event.key.toLowerCase())
  ) {
    return;
  }

  if (![...allowedKeys, ...controlKeys].includes(event.key)) {
    event.preventDefault();
  }

  onKeyDown?.(event);
};

export const handleInputBlur = (
  event,
  { id, inputIndex, onChange, onBlur, field, config }
) => {
  const value = event.target.value;
  const finalValue =
    !value && config?.defaultValue ? config.defaultValue : value;

  onChange({ id, value: finalValue, inputIndex, isOnBlur: true });
  onBlur?.(id, finalValue, inputIndex);
  field.onBlur(event);
};

export const getMultiInputError = (isMultiInput, meta) => {
  if (!isMultiInput || !meta.error) return null;

  if (Array.isArray(meta.error)) {
    const hasValuesError = meta.error.some(
      optionError =>
        Array.isArray(optionError.values) && optionError.values.some(identity)
    );

    if (hasValuesError) {
      return t("neetoMolecules.optionFields.allFieldsRequired");
    }
  }

  return null;
};
